<template>
    <SafetyInfoWin v-show="false"
                   v-on:loaded-safety-info="loadedSafetyInfoHandle"
                   ref="safetyInfoWin" />
</template>

<script>
import { $_TYPE, $_WC, $_NM } from '@/confs/common.const';
import gripUtil from "@/libs/grip.util";
import naverMapUtil from '@/libs/grip.naver.map.util';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import SafetyInfoWin from "@/views/realtime/SafetyInfoWin.vue";

import { mapGetters } from "vuex";
export default {
    components :{
        SafetyInfoWin,
    },
    data(){
        return {
            groupName: 'Safety',
        };
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            subMenuList: 'getSubMenuList',
            safetyList: 'getSafetyList',
        }),
    },
    watch: {
        selectedSubMenus: {
            immediate: false,
            handler(newVal, oldVal) {
                this.placeMarkers();
            }
        },
        safetyList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.placeMarkers();
            }
        },
    },
    created() {
    },
    methods: {
        placeMarkers(){
            if(typeof this.geoJsonDrawing !== $_TYPE.UNDEF) {
                if (this.selectedTopMenu === 'Safety') {
                    this.removeMarker(this.groupName);
                    this.safetyList.forEach(safety => {
                        if (this.selectedSubMenus.includes(safety.safetyCategoryCd)) {
                            if (safety.wtmX && safety.wtmY) {
                                let latlng = naverMapUtil.convertWgs84Coords(safety.wtmY, safety.wtmX);
                                safety.lttdVal = latlng[0];
                                safety.lgtdVal = latlng[1];
                                let fileExt = '.png';
                                if(safety.safetyCategoryCd == '0' || safety.safetyCategoryCd == '1') {
                                    fileExt = '.gif';
                                }
                                safety.marker = this.makeMarker(this.groupName, safety, () => {
                                    this.$refs.safetyInfoWin.setRegisterNo(safety.registerNo);
                                }, 'marker_safety_' + safety.safetyCategoryCd + fileExt, "img/marker/", $_NM.MARKER_W, $_NM.MARKER_H);
                            }
                        }
                    });
                    this.showMarkers(this.groupName, true);
                }
            }
        },
        loadedSafetyInfoHandle(content) {
            this.openInfoWin(content);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
